import { ThemeUICSSObject } from '@apia/theme';

const gantt: ThemeUICSSObject = {
  '._3_ygE': {
    display: 'table',
    borderBottom: '#e6e4e4 1px solid',
    borderTop: '#e6e4e4 1px solid',
    borderLeft: '#e6e4e4 1px solid',
  },
  '._1nBOt': { display: 'table-row', listStyle: 'none' },
  '._2eZzQ': {
    borderRight: '1px solid rgb(196, 196, 196)',
    opacity: 1,
    marginLeft: '-2px',
  },
  '._WuQ0f': {
    display: 'table-cell',
    verticalAlign: ['-webkit-baseline-middle', 'middle'],
  },
  '._3ZbQT': {
    display: 'table',
    borderBottom: '#e6e4e4 1px solid',
    borderLeft: '#e6e4e4 1px solid',
  },
  '._34SS0': { display: 'table-row', textOverflow: 'ellipsis' },
  '._34SS0:nth-of-type(even)': { backgroundColor: '#f5f5f5' },
  '._3lLk3': {
    display: 'table-cell',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '._nI1Xw': { display: 'flex' },
  '._2QjE6': {
    color: 'rgb(86 86 86)',
    fontSize: '0.6rem',
    padding: '0.15rem 0.2rem 0rem 0.2rem',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    cursor: 'pointer',
  },
  '._2TfEi': {
    fontSize: '0.6rem',
    paddingLeft: '1rem',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  '._3T42e': {
    background: '#fff',
    padding: '12px',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)',
  },
  '._29NTg': { fontSize: '12px', marginBottom: '6px', color: '#666' },
  '._25P-K': {
    position: 'absolute',
    display: 'flex',
    flexShrink: 0,
    pointerEvents: 'none',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  '._3gVAq': {
    visibility: 'hidden',
    position: 'absolute',
    display: 'flex',
    pointerEvents: 'none',
  },
  '._1eT-t': {
    overflow: 'hidden auto',
    width: '1rem',
    flexShrink: 0,
    scrollbarWidth: 'thin',
  },
  '._1eT-t::-webkit-scrollbar': { width: '1.1rem', height: '1.1rem' },
  '._1eT-t::-webkit-scrollbar-corner': { background: 'transparent' },
  '._1eT-t::-webkit-scrollbar-thumb': {
    border: '6px solid transparent',
    background: [
      'rgba(0, 0, 0, 0.2)',
      'var(--palette-black-alpha-20, rgba(0, 0, 0, 0.2))',
    ],
    borderRadius: '10px',
    backgroundClip: 'padding-box',
  },
  '._1eT-t::-webkit-scrollbar-thumb:hover': {
    border: '4px solid transparent',
    background: [
      'rgba(0, 0, 0, 0.3)',
      'var(--palette-black-alpha-30, rgba(0, 0, 0, 0.3))',
    ],
    backgroundClip: 'padding-box',
  },
  '._2dZTy': { fill: '#fff' },
  '._2dZTy:nth-of-type(even)': { fill: '#f5f5f5' },
  '._3rUKi': { stroke: '#ebeff2' },
  '._RuwuK': { stroke: '#e6e4e4' },
  '._9w8d5': {
    textAnchor: 'middle',
    fill: '#333',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  '._1rLuZ': { stroke: '#e6e4e4' },
  '._2q1Kt': {
    textAnchor: 'middle',
    fill: '#555',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  '._35nLX': { fill: '#ffffff', stroke: '#e0e0e0', strokeWidth: 1.4 },
  '._KxSXS': { cursor: 'pointer', outline: 'none' },
  '._KxSXS:hover ._3w_5u': { visibility: 'visible', opacity: 1 },
  '._3w_5u': {
    fill: '#ddd',
    cursor: 'ew-resize',
    opacity: 0,
    visibility: 'hidden',
  },
  '._31ERP': {
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    strokeWidth: 0,
  },
  '._RRr13': { cursor: 'pointer', outline: 'none' },
  '._2P2B1': {
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  '._1KJ6x': { cursor: 'pointer', outline: 'none' },
  '._2RbVy': {
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    opacity: 0.6,
  },
  '._2pZMF': {
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  '._3zRJQ': {
    fill: '#fff',
    textAnchor: 'middle',
    fontWeight: 'lighter',
    dominantBaseline: 'central',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  '._3KcaM': {
    fill: '#555',
    textAnchor: 'start',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  '._CZjuD': { overflow: 'hidden', fontSize: '0', margin: '0', padding: '0' },
  '._2B2zv': { margin: '0', padding: '0', overflow: 'hidden' },
  '._3eULf': {
    display: 'flex',
    padding: '0',
    margin: '0',
    listStyle: 'none',
    outline: 'none',
    position: 'relative',
  },
  '._2k9Ys': {
    overflow: 'auto',
    maxWidth: '100%',
    scrollbarWidth: 'thin',
    height: '1.2rem',
  },
  '._2k9Ys::-webkit-scrollbar': { width: '1.1rem', height: '1.1rem' },
  '._2k9Ys::-webkit-scrollbar-corner': { background: 'transparent' },
  '._2k9Ys::-webkit-scrollbar-thumb': {
    border: '6px solid transparent',
    background: [
      'rgba(0, 0, 0, 0.2)',
      'var(--palette-black-alpha-20, rgba(0, 0, 0, 0.2))',
    ],
    borderRadius: '10px',
    backgroundClip: 'padding-box',
  },
  '._2k9Ys::-webkit-scrollbar-thumb:hover': {
    border: '4px solid transparent',
    background: [
      'rgba(0, 0, 0, 0.3)',
      'var(--palette-black-alpha-30, rgba(0, 0, 0, 0.3))',
    ],
    backgroundClip: 'padding-box',
  },
  '@media only screen and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2)':
    {},
  '._19jgW': { height: '1px' },
};

export default gantt;
